import React,{useState} from "react";
import { AreaChart, Area, XAxis, YAxis, Tooltip, ResponsiveContainer } from "recharts";
import "../../styles/DashboardFixes.css";

export default function ResellerDashboard() {
  const [summary] = useState({ mrr:1240 });
  const forecast = 1420;

  const trend = [
    { m:"Jan", mrr:800 },
    { m:"Feb", mrr:980 },
    { m:"Mar", mrr:1240 }
  ];

  return (
    <>
      <div className="hero-strip">
        <p className="text-muted text-sm">Monthly snapshot</p>
        <h2 className="mt-2">£{summary.mrr} · £{forecast} projected</h2>
      </div>

      <div className="panel">
        <h3 className="mb-6">MRR Growth</h3>
        <ResponsiveContainer width="100%" height={260}>
          <AreaChart data={trend}>
            <XAxis dataKey="m"/>
            <YAxis/>
            <Tooltip/>
            <Area dataKey="mrr" stroke="#22c55e" fill="#22c55e55"/>
          </AreaChart>
        </ResponsiveContainer>
      </div>
    </>
  );
}
